module.exports = __webpack_public_path__ + "page-92d620f2/marketing-c0837343d84484a7e4437eb83ce2da3d.webp";